import api from './api';

const kpisService = {
  getMyKpis: async (params = {}) => {
    const response = await api.get('/kpis/me', { params });
    return response.data;
  },

  getTeamKpis: async (params = {}) => {
    const response = await api.get('/kpis/team', { params });
    return response.data;
  },

  getDriverKpis: async (driverId, params = {}) => {
    const response = await api.get(`/kpis/driver/${driverId}`, { params });
    return response.data;
  },

  getAllKpis: async (params = {}) => {
    const response = await api.get('/kpis', { params });
    return response.data;
  },
};

export default kpisService;
